import { Box, Button, Flex, Grid, GridItem, Icon, Image, Separator, Text } from "@chakra-ui/react";
import { CaretRightIcon, CaretUpIcon } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useRef, useState } from "react";

const Description = ({ dataDevelopment, isGreaterThanMd, formatPrice }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (textRef.current) {
                const { scrollHeight, clientHeight } = textRef.current;
                setIsTruncated(scrollHeight > clientHeight);
            }
        }, 1); // 1 milisegundo para que cargue el texto a evaluar

        return () => clearTimeout(timeout);
    }, [dataDevelopment?.comments]);

    const propertyTypes = {
        APARTMENT: "Departamentos",
        HOUSE: "Casas",
        TERRAIN: "Terrenos",
        DUPLEX_HOUSE: "Casas Duplex",
        OFFICE: "Oficinas",
        CONSULTING_ROOM: "Consultorios",
        WAREHOUSE: "Bodegas",
        INDUSTRIAL_BUILDING: "Naves Industriales",
        SHOP: "Locales",
        SHOP_SHOPPING_CENTER: "Locales Comerciales",
        RANCH: "Ranchos",
        BUILDING: "Edificios",
        HOTEL: "Hoteles",
        EVENT_HALL: "Salones de Eventos",
        COTTAGE: "Cabañas",
    };

    return (
        <>
            <Grid
                templateColumns={{ base: "repeat(4, 1fr)" }}
                gap={{ base: 2, md: 4 }}
                textAlign="center"
            >
                <GridItem colSpan={1}>
                    <Box bg="#DDDDDD" py={2} px={4}>
                        <Text fontSize={{ base: "sm", md: "md" }} color="#4F4F4F">
                            {propertyTypes?.[dataDevelopment?.property_type] || "Otros"}
                        </Text>
                    </Box>
                </GridItem>
                <GridItem colSpan={1}>
                    <Box bg="#DFF2FF" py={2} px={4} maxW="fit-content">
                        <Text fontSize={{ base: "sm", md: "md" }} color="#002B49">
                            {dataDevelopment?.operation_props.presale
                                ? "Preventa"
                                : dataDevelopment?.operation_props.sale
                                  ? "Venta"
                                  : "Renta"}
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Text color="black" fontWeight="400" fontSize={{ base: "sm", md: "lg" }} pt={2}>
                {dataDevelopment?.operation_props.presale?.min_price !== 0 &&
                dataDevelopment?.operation_props.sale?.min_price !== 0 ? (
                    <>
                        {`Desde: ${formatPrice(dataDevelopment?.operation_props?.presale?.min_price && dataDevelopment?.operation_props?.presale?.min_price !== "1" && dataDevelopment?.operation_props?.presale?.min_price !== 1 && dataDevelopment?.operation_props?.presale ? dataDevelopment?.operation_props?.presale?.min_price : dataDevelopment?.min_price || dataDevelopment?.operation_props?.sale?.min_price || dataDevelopment?.operation_props?.lease?.min_price)} MXN`}
                    </>
                ) : null}

                {dataDevelopment?.operation_props?.presale?.max_price !== 0 &&
                dataDevelopment?.operation_props?.sale?.max_price !== 0 ? (
                    <>
                        <strong style={{ marginLeft: "10px", marginRight: "10px" }}>
                            &middot;
                        </strong>
                        {`Hasta: ${formatPrice(dataDevelopment?.max_price || dataDevelopment?.operation_props?.presale?.max_price || dataDevelopment?.operation_props?.sale?.max_price || dataDevelopment?.operation_props?.lease?.max_price)} MXN`}
                    </>
                ) : null}
            </Text>
            <Grid
                templateColumns={{ base: "repeat(3, 1fr)", xl: "repeat(6, 1fr)" }}
                pt={4}
                gap={2}
                maxW={{ md: "50vw" }}
            >
                {dataDevelopment?.product_props?.min_ground_size > 0 ||
                dataDevelopment?.product_props?.min_construction_size > 0 ||
                dataDevelopment?.min_construction_size > 0 ? (
                    <GridItem colSpan={3}>
                        <Flex>
                            <Box
                                backgroundColor="#E3E3E3"
                                p={2}
                                alignItems="center"
                                borderWidth={1}
                                borderColor="#A5A5A5"
                                borderLeftRadius="md"
                            >
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/cinta-metrica.svg"
                                    alt="cinta_metrica"
                                    boxSize="20px"
                                />
                            </Box>
                            <Box
                                backgroundColor="#303030"
                                p={2}
                                alignItems="center"
                                borderRightRadius="md"
                                w={{ xl: "21vw" }}
                            >
                                <Text color="#FFFFFF" fontWeight={400} fontSize="sm" px={2}>
                                    Desde:{" "}
                                    {dataDevelopment?.product_props?.min_ground_size > 0
                                        ? dataDevelopment?.product_props?.min_ground_size.toFixed(2)
                                        : dataDevelopment?.product_props?.min_construction_size
                                          ? dataDevelopment?.product_props?.min_construction_size.toFixed(
                                                2
                                            )
                                          : dataDevelopment?.min_construction_size.toFixed(2)}{" "}
                                    m&sup2;
                                    <strong style={{ marginLeft: "10px", marginRight: "10px" }}>
                                        &middot;
                                    </strong>
                                    Hasta:{" "}
                                    {dataDevelopment?.product_props?.max_ground_size > 0
                                        ? dataDevelopment?.product_props?.max_ground_size.toFixed(2)
                                        : dataDevelopment?.product_props?.max_construction_size
                                          ? dataDevelopment?.product_props?.max_construction_size.toFixed(
                                                2
                                            )
                                          : dataDevelopment?.max_construction_size.toFixed(2)}{" "}
                                    m&sup2;
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                ) : null}

                {dataDevelopment?.product_props?.min_bedrooms > 0 ||
                dataDevelopment?.product_props?.max_bedrooms > 0 ||
                dataDevelopment?.min_bedrooms > 0 ||
                dataDevelopment?.max_bedrooms > 0 ? (
                    <GridItem>
                        <Flex>
                            <Box
                                backgroundColor="#E3E3E3"
                                p={2}
                                alignItems="center"
                                borderWidth={1}
                                borderColor="#A5A5A5"
                                borderLeftRadius="md"
                            >
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/cama.svg"
                                    alt="cama"
                                    boxSize="20px"
                                />
                            </Box>
                            <Box
                                backgroundColor="#303030"
                                p={2}
                                alignItems="center"
                                borderRightRadius="md"
                            >
                                <Text color="#FFFFFF" fontWeight={400} fontSize="sm" px={2}>
                                    {dataDevelopment?.product_props?.min_bedrooms
                                        ? dataDevelopment?.product_props?.min_bedrooms
                                        : dataDevelopment?.min_bedrooms
                                          ? dataDevelopment?.min_bedrooms
                                          : ""}
                                    {(dataDevelopment?.product_props?.min_bedrooms &&
                                        dataDevelopment?.product_props?.max_bedrooms) ||
                                    (dataDevelopment?.min_bedrooms && dataDevelopment?.min_bedrooms)
                                        ? " a "
                                        : null}
                                    {dataDevelopment?.product_props?.max_bedrooms
                                        ? dataDevelopment?.product_props?.max_bedrooms
                                        : dataDevelopment?.max_bedrooms
                                          ? dataDevelopment?.max_bedrooms
                                          : ""}
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                ) : null}

                {dataDevelopment?.product_props?.min_bathrooms > 0 ||
                dataDevelopment?.product_props?.max_bathrooms > 0 ||
                dataDevelopment?.min_bathrooms > 0 ||
                dataDevelopment?.max_bathrooms > 0 ? (
                    <GridItem>
                        <Flex>
                            <Box
                                backgroundColor="#E3E3E3"
                                p={2}
                                alignItems="center"
                                borderWidth={1}
                                borderColor="#A5A5A5"
                                borderLeftRadius="md"
                            >
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/inodoro.svg"
                                    alt="inodoro"
                                    boxSize="17px"
                                />
                            </Box>
                            <Box
                                backgroundColor="#303030"
                                p={2}
                                alignItems="center"
                                borderRightRadius="md"
                            >
                                <Text color="#FFFFFF" fontWeight={400} fontSize="sm" px={2}>
                                    {dataDevelopment?.product_props?.min_bathrooms
                                        ? dataDevelopment?.product_props?.min_bathrooms
                                        : dataDevelopment?.min_bathrooms
                                          ? dataDevelopment?.min_bathrooms
                                          : ""}
                                    {(dataDevelopment?.product_props?.min_bathrooms &&
                                        dataDevelopment?.product_props?.max_bathrooms) ||
                                    (dataDevelopment?.min_bathrooms &&
                                        dataDevelopment?.max_bathrooms)
                                        ? " a "
                                        : null}
                                    {dataDevelopment?.product_props?.max_bathrooms
                                        ? dataDevelopment?.product_props?.max_bathrooms
                                        : dataDevelopment?.max_bathrooms
                                          ? dataDevelopment?.max_bathrooms
                                          : ""}
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                ) : null}

                {dataDevelopment?.product_props?.min_parking_lots > 0 ||
                dataDevelopment?.product_props?.max_parking_lots > 0 ||
                dataDevelopment?.min_parking_lots > 0 ||
                dataDevelopment?.max_parking_lots > 0 ? (
                    <GridItem>
                        <Flex>
                            <Box
                                backgroundColor="#E3E3E3"
                                p={2}
                                alignItems="center"
                                borderWidth={1}
                                borderColor="#A5A5A5"
                                borderLeftRadius="md"
                            >
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/carro-familiar.svg"
                                    alt="carro"
                                    boxSize="20px"
                                />
                            </Box>
                            <Box
                                backgroundColor="#303030"
                                p={2}
                                alignItems="center"
                                borderRightRadius="md"
                            >
                                <Text color="#FFFFFF" fontWeight={400} fontSize="sm" px={2}>
                                    {dataDevelopment?.product_props?.min_parking_lots
                                        ? dataDevelopment?.product_props?.min_parking_lots
                                        : dataDevelopment?.min_parking_lots
                                          ? dataDevelopment?.min_parking_lots
                                          : ""}
                                    {(dataDevelopment?.product_props?.min_parking_lots &&
                                        dataDevelopment?.product_props?.max_parking_lots) ||
                                    (dataDevelopment?.min_parking_lots &&
                                        dataDevelopment?.max_parking_lots)
                                        ? " a "
                                        : null}
                                    {dataDevelopment?.product_props?.max_parking_lots
                                        ? dataDevelopment?.product_props?.max_parking_lots
                                        : dataDevelopment?.max_parking_lots
                                          ? dataDevelopment?.max_parking_lots
                                          : ""}
                                </Text>
                            </Box>
                        </Flex>
                    </GridItem>
                ) : null}
            </Grid>
            <Box pb={5}>
                <Text fontWeight="700" fontSize="lg" mt={6} color="black">
                    Descripción
                </Text>
                <Text
                    ref={textRef}
                    fontWeight="400"
                    fontSize="sm"
                    color="black"
                    textAlign="justify"
                    pr={{ md: 12 }}
                    mt={3}
                    lineClamp={isExpanded ? undefined : isGreaterThanMd ? 2 : 5}
                    overflow="hidden"
                    textOverflow="ellipsis"
                >
                    {dataDevelopment?.comments}
                </Text>
                <Flex justifyContent="center">
                    {isTruncated && (
                        <Button
                            fontWeight={400}
                            size="lg"
                            variant="link"
                            color="blue.500"
                            _hover={{ textDecoration: "none" }}
                            mt={3}
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? "Ver menos" : "Ver más"}
                            <Icon aria-hidden="true" boxSize={4} color="blue.500">
                                {isExpanded ? (
                                    <CaretUpIcon weight="bold" />
                                ) : (
                                    <CaretRightIcon weight="bold" />
                                )}
                            </Icon>
                        </Button>
                    )}
                </Flex>
            </Box>
            <Separator borderColor="#B1B1B1" />
        </>
    );
};

export default Description;
